// src/pages/Contact.js
import { Box, Heading, Text, AspectRatio } from "@chakra-ui/react";
import ReviewsCarousel from "../components/ReviewsCarousel";
import { useTranslation } from "react-i18next";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <Box p={5}>
      <Heading size={{ base: "xl", md: "2xl"}} mb={5}>
        {t("contact_title")}
      </Heading>

      <Text fontSize="lg">
        📍 {t("contact_address_label")}: <a
          href="https://maps.google.com/?q=Πέλοπος 26, Πάτρα 263 35"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3182ce", textDecoration: "underline" }}
        >
          {t("contact_address")}
        </a>
      </Text>
      <Text fontSize="lg">
        📞 {t("contact_phone_label")}: <a href="tel:2610640582" style={{ color: "#3182ce", textDecoration: "underline" }}>261 064 0582</a>
      </Text>
      <Text fontSize="lg">
        📧 {t("contact_email_label")}: <a href="mailto:geo_stefanidis@hotmail.com" style={{ color: "#3182ce", textDecoration: "underline" }}>geo_stefanidis@hotmail.com</a>
      </Text>

      {/* Χάρτης (responsive, 16:9) */}
      <Box mt={6} borderRadius="2xl" overflow="hidden" boxShadow="0 10px 30px rgba(0,0,0,.35)">
        <AspectRatio ratio={16 / 9} w="100%">
          <Box
            as="iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6268.634399969226!2d21.747264852447802!3d38.22574620944061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135e360ff623c48d%3A0x937e59a377cae433!2sArena%20Sports%20Center!5e0!3m2!1sel!2sgr!4v1756902563206!5m2!1sel!2sgr"
            border="0"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </AspectRatio>
      </Box>
      <Box mt={{ base: 10, md: 14 }}>
        <Heading size="lg" mb={4}>{t("contact_reviews_title")}</Heading>
        <ReviewsCarousel />
      </Box>
    </Box>
  );
}
